import React, { Component } from "react";
import PropTypes from "prop-types";
import serialize from "form-serialize";

import CustomSelect from "./CustomSelect";
import CustomDatepicker from "./Datepicker/CustomDatepicker";
import CustomSelectSearchable from "./CustomSelectSearchable";

class ClientsFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      category: [],
      culture: [],
      callFrom: null,
      callTo: null,
      lastCallFrom: null,
      lastCallTo: null
    };
  }

  handleSelectChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  setCallFrom = date => {
    this.handleDateUpdate("callFrom", date);
  };

  setCallTo = date => {
    this.handleDateUpdate("callTo", date);
  };

  setLastCallFrom = date => {
    this.handleDateUpdate("lastCallFrom", date);
  };

  setLastCallTo = date => {
    this.handleDateUpdate("lastCallTo", date);
  };

  handleDateUpdate = (field, date) => {
    this.setState({
      [field]: date
    });
  };

  onSubmit = e => {
    e.preventDefault();

    const data = serialize(this.form, { hash: true });

    data.type = this.props.type;
    if (this.state.category.length) {
      data.category = this.state.category.join(" ");
      delete data.grainValue;
    }
    if (this.state.culture.length) {
      data.culture = this.state.culture.join(" ");
    }
    this.props.onSubmit({ ...data }, { page: 1, size: 70 });
  };

  onExportData = e => {
      e.preventDefault();

      const data = serialize(this.form, { hash: true });
      data.type = this.props.type;
      if (this.state.category.length) {
          data.category = this.state.category.join(" ");
      }
      if (this.state.culture.length) {
          data.culture = this.state.culture.join(" ");
      }

      this.props.onExportData({ ...data });
  };


  render() {
    const { selectsData } = this.props;

    return (
      <div className="mr-bottom-40">
        <form
          action=""
          method=""
          id="do-search"
          className="custom-form filter clearfix"
          ref={c => (this.form = c)}
        >
          <h4 className="text-center">Параметры поиска</h4>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Номер</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="number"
                />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Культура</div>
              <div className="col-xs-6 mr-left-20">
                {selectsData ? (
                  <CustomSelectSearchable
                    name="culture"
                    options={selectsData.cultures}
                    onSelect={this.handleSelectChange}
                    values={this.state.culture}
                    placeholder="Выберите культуру"
                    multiple
                  />
                ) : null}
              </div>
              <div className={!this.state.culture.length ? 'hidden' : ''}>
                  <div className="col-xs-3 custom-form__label mr-top-20">Объем зерна от</div>
                  <div className="col-xs-6 mr-left-20 mr-top-20">
                      <input
                          disabled={!this.state.culture.length}
                          type="number"
                          className="custom-form__input"
                          name="grainValue"
                      />
                  </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Название</div>
              <div className="col-xs-6 mr-left-20">
                <input type="text" className="custom-form__input" name="name" />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Цена</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">от</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="price_from"
                    className="custom-form__input"
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="price_to"
                    className="custom-form__input"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Категория</div>
              <div className="col-xs-6 mr-left-20">
                {selectsData ? (
                  <CustomSelect
                    name="category"
                    placeholder="Выберите категорию"
                    options={selectsData.categories}
                    onSelect={this.handleSelectChange}
                    values={this.state.category}
                    multiple
                  />
                ) : null}
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Телефон</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="phone"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Адрес</div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="address"
                />
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">
                Владелец <br />
                контакта
              </div>
              <div className="col-xs-6 mr-left-20">
                <input
                  type="text"
                  className="custom-form__input"
                  name="contact_owner"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Звонили</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">c</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="last_call_from"
                    selectedDay={this.state.lastCallFrom}
                    onDayChange={this.setLastCallFrom}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="last_call_to"
                    selectedDay={this.state.lastCallTo}
                    onDayChange={this.setLastCallTo}
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Площадь земли</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">от</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="area_full_from"
                    className="custom-form__input"
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <input
                    type="text"
                    name="area_full_to"
                    className="custom-form__input"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label">Позвонить</div>
              <div className="col-xs-3 mr-right-20">
                <div className="col-xs-2 prefix custom-form__label">с</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="call_from"
                    selectedDay={this.state.callFrom}
                    onDayChange={this.setCallFrom}
                  />
                </div>
              </div>
              <div className="col-xs-3">
                <div className="col-xs-2 prefix custom-form__label">до</div>
                <div className="col-xs-10">
                  <CustomDatepicker
                    name="call_to"
                    selectedDay={this.state.callTo}
                    onDayChange={this.setCallTo}
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="col-xs-3 custom-form__label mr-bottom-20">
                Сработались
              </div>
              <div className="col-xs-3 mr-bottom-20">
                <input type="checkbox" name="is_worked" />
              </div>
              <div className="col-xs-3 custom-form__label mr-bottom-20">
                НДС
              </div>
              <div className="col-xs-3 mr-bottom-20">
                <input type="checkbox" name="is_work_vat" />
              </div>
              <div className="col-xs-3 custom-form__label">Без НДС</div>
              <div className="col-xs-3">
                <input type="checkbox" name="is_work_no_vat" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <div className="col-xs-2 custom-form__label mr-bottom-20 mr-right-40">
                Звонил последним
              </div>
              <div className="col-xs-2 mr-bottom-20">
                <input type="checkbox" name="call_by_me" />
              </div>
              <div className="col-xs-3 custom-form__label mr-bottom-20 mr-right-40">
                Договор
              </div>
              <div className="col-xs-3 mr-bottom-20">
                <input type="checkbox" name="contract" />
              </div>
            </div>
          </div>
        </form>
        <div className="row">
        { selectsData.role === "admin" ?
            (<button
                type="submit"
                className="btn btn-primary pull-left col-xs-3"
                onClick={this.onExportData}
            >
                Экспорт в Excel
            </button>)
         : null }
        <button
          type="submit"
          formTarget="do-search"
          onClick={this.onSubmit}
          className="btn btn-success pull-right col-xs-3"
        >
          Применить
        </button>
        </div>
        { selectsData.role === "admin" ?
            (<div className="row">{ this.props.downloadingExportUrl ? (<a href={this.props.downloadingExportUrl}>Скачать экспорт</a>) : null }</div>) : null }
      </div>
    );
  }
}

ClientsFilter.propTypes = {
  selectsData: PropTypes.object,
  onSubmit: PropTypes.func,
  downloadingExportUrl: PropTypes.string,
  type: PropTypes.string.isRequired
};

ClientsFilter.defaultProps = {
  onSubmit: () => {}
};

export default ClientsFilter;



// WEBPACK FOOTER //
// ./components/ClientsFilter.js